
import { Component, inject, ChangeDetectionStrategy, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '../../../../core/services/auth.service';
import { ROLE_LABELS } from '../../../../core/models/enums';
import { Router } from '@angular/router';
import { BranchService } from '../../../../core/services/branch.service';
import { UiService } from '../../../../core/services/ui.service';

@Component({
  selector: 'app-admin-header',
  standalone: true,
  imports: [CommonModule, MatToolbarModule, MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './admin-header.html',
  styleUrl: './admin-header.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminHeaderComponent {
  private authService = inject(AuthService);
  private branchService = inject(BranchService);
  private uiService = inject(UiService);
  private router = inject(Router);

  userProfile = this.authService.userProfile;
  pageTitle = this.uiService.pageTitle;

  // Branch Logic
  branches = computed(() => (this.branchService.userBranchesResource.value() as any[]) ?? []);

  // Ocultar selector para SuperAdmin (siempre ve todo)
  // Mostrar para OWNER (siempre) y para ADMIN solo si tiene mas de 1 sucursal
  showBranchSelector = computed(() => {
    const role = this.authService.userRole();
    const isSA = this.authService.isSuperAdmin();
    const isOwner = this.authService.isOwner();
    const branchCount = this.branches().length;

    if (isSA) return false;
    if (isOwner) return true;
    return branchCount > 1; // Para ADMIN y otros
  });

  isOwner = this.authService.isOwner;
  workingBranchId = this.branchService.workingBranchId;   // Navegación/Terminología
  workingBranchName = computed(() => this.branchService.workingBranch()?.name || 'Sucursal Activa');

  userInitials = computed(() => {
    const name = this.userProfile()?.full_name || 'U';
    return name.substring(0, 2).toUpperCase();
  });

  userRoleLabel = computed(() => {
    const role = this.authService.userRole();
    return role ? ROLE_LABELS[role] : '';
  });

  selectBranch(branchId: string) {
    this.branchService.setWorkingBranch(branchId);
  }

  async logout() {
    await this.authService.signOut();
    this.router.navigate(['/auth/login']);
  }
}
